@if (this.fusionService.selectedRise) {
  <div class="fusion-container">
    <!-- ===== INTRO ===== -->
    <div class="fusion-intro">
      <img
        src="assets/iframely/rise.png"
        alt="Rise"
        class="fusion-logo"
        />
      <div>
        <h5
          class="mb-0"
          i18n="@@rise-upload-heading"
        >Articulate Rise-Kurs</h5>
        <small
          class="text-muted"
          i18n="@@rise-intro-description"
          >
          Verbinde einen Articulate Rise-Kurs mit diesem Fusion-View, um Lerninhalte interaktiv bereitzustellen.
        </small>
      </div>
    </div>
    <hr class="fusion-divider" />
    <!-- ===== TITEL + IDENTIFIKATOR ===== -->
    <section class="fusion-section">
      <h6
        class="fusion-section-title"
        i18n="@@title"
      >Titel</h6>
      <input
        pInputText
        type="text"
        [(ngModel)]="this.fusionService.selectedRise.metadata.title"
        [ngModelOptions]="{ updateOn: 'blur' }"
        (ngModelChange)="this.fusionService.updateFusionFieldFor(this.fusionService.selectedRise._id, 'title', this.fusionService.selectedRise.metadata.title)"
        class="w-100"
        >
      <small class="fusion-section-hint mt-1 d-block">
        <span i18n="@@fusion-view-name">Identifikator</span>: {{ this.fusionService.selectedRise.metadata.name }}
      </small>
    </section>
    <hr class="fusion-divider" />
    <div class="fusion-sections">
      <!-- ===== 1. UPLOAD-BEREICH ===== -->
      <section class="fusion-section">
        <h6
          class="fusion-section-title"
          i18n="@@rise-course-file-heading"
        >Kursdatei</h6>
        <!-- Upload-Fortschritt -->
        @if (this.fusionService.uploadProgress) {
          <div class="upload-progress">
            <div class="upload-progress-header">
              <i class="ri-loader-4-line ri-spin me-2"></i>
              <span class="upload-progress-text">{{this.fusionService.uploadProgress.message}}</span>
              <span class="upload-progress-percent">{{ (this.fusionService.uploadProgress.step /
              this.fusionService.uploadProgress.totalSteps * 100) | number:'1.0-0' }}&thinsp;%</span>
            </div>
            <p-progressBar
              [value]="this.fusionService.uploadProgress.step / this.fusionService.uploadProgress.totalSteps * 100"
              [showValue]="false"
              [style]="{ height: '6px' }"
            ></p-progressBar>
          </div>
        }
        <!-- Kein Upload vorhanden -->
        @if (!this.fusionService.uploadProgress && !this.fusionService.selectedRise.metadata.uploader) {
          <div class="upload-empty">
            <i class="ri-upload-cloud-2-line upload-empty-icon"></i>
            <p
              class="upload-empty-text"
              i18n="@@rise-upload-empty-description"
              >
              Noch kein Kurs hochgeladen. Lade die SCORM-Exportdatei (z.&nbsp;B. ZIP) hoch, um diesen Fusion-View zu
              verwenden.
            </p>
            <p-button
              size="small"
              severity="primary"
              icon="ri-file-upload-line"
              (onClick)="fileInput.click()"
              i18n-label="@@rise-upload-btn"
              label="Kurs hochladen"
            ></p-button>
            <input
              type="file"
              class="file-input d-none"
              (change)="this.uploadFile($event)"
              #fileInput
              />
          </div>
        }
        <!-- Upload vorhanden -->
        @if (!this.fusionService.uploadProgress && this.fusionService.selectedRise.metadata.uploader) {
          <div class="upload-info-card">
            <div class="upload-info-card-header">
              <div class="upload-info-icon-wrap">
                <i class="ri-file-zip-line"></i>
              </div>
              <div class="upload-info-body">
                <span class="upload-info-filename">
                  {{ this.fusionService.selectedRise.filename }}
                </span>
                <div class="upload-info-meta">
                  <span>
                    <i class="ri-user-line me-1"></i>{{ this.fusionService.selectedRise.metadata.uploader }}
                  </span>
                  <span>
                    <i class="ri-calendar-line me-1"></i>{{ this.fusionService.selectedRise.uploadDate |
                    date:'dd.MM.yyyy
                    HH:mm' }}
                  </span>
                  <span>
                    <i class="ri-hard-drive-3-line me-1"></i>{{ (this.fusionService.selectedRise.length / (1024 *
                    1024)
                    |
                    number:'1.2-2') }} MB
                  </span>
                </div>
              </div>
              <p-button
                [outlined]="true"
                severity="secondary"
                size="small"
                icon="ri-loop-left-line"
                (onClick)="replaceFileInput.click()"
                i18n-pTooltip="@@rise-replace-upload-tooltip"
                pTooltip="Datei austauschen"
                tooltipPosition="top"
                i18n-label="@@rise-replace-upload"
                label="Austauschen"
              ></p-button>
              <input
                type="file"
                class="file-input d-none"
                (change)="this.uploadFile($event)"
                #replaceFileInput
                />
            </div>
          </div>
        }
      </section>
      <hr class="fusion-divider" />
      <!-- ===== 2. DARSTELLUNGSOPTIONEN (INITIAL) + PREVIEW ===== -->
      <section class="fusion-section">
        <h6
          class="fusion-section-title"
          i18n="@@fusionconfig-display-options"
        >Darstellungsoptionen (Initial)</h6>
        <small
          class="fusion-section-hint"
          i18n="@@fusionconfig-display-options-hint"
          >
          Lege fest, wie der Bot und der Inhalt im Fusion-View dargestellt werden.
        </small>
        <div class="display-options-row">
          <div class="display-options-controls">
            <!-- Ansichtsmodus -->
            <div class="display-option-field">
              <p-select
                id="pvViewModeSelect"
                [options]="this.viewModeOptions"
                optionLabel="label"
                optionValue="value"
                [(ngModel)]="this.fusionService.selectedRise.metadata.viewMode"
                [ngModelOptions]="{updateOn: 'blur'}"
                (ngModelChange)="this.fusionService.updateFusionField('viewMode', this.fusionService.selectedRise.metadata.viewMode)"
              ></p-select>
            </div>
            <!-- Bot-Typ -->
            <div class="display-option-field">
              <p-selectbutton
                [options]="this.botTypeOptions"
                optionLabel="label"
                optionValue="value"
                [(ngModel)]="this.fusionService.selectedRise.metadata.bottype"
                (ngModelChange)="this.fusionService.updateFusionField('bottype',this.fusionService.selectedRise.metadata.bottype)"
                [unselectable]="true"
                >
                <ng-template
                  let-item
                  pTemplate="item"
                  >
                  <i
                    [class]="item.icon"
                    class="me-1"
                  ></i>
                  <span>{{ item.label }}</span>
                </ng-template>
              </p-selectbutton>
            </div>
            <!-- Bot anzeigen -->
            <div class="display-option-toggle">
              <p-toggleswitch
                [ngModel]="!this.fusionService.selectedRise.metadata.botHidden"
                (ngModelChange)="this.fusionService.selectedRise.metadata.botHidden = !$event; this.fusionService.updateFusionField('botHidden', this.fusionService.selectedRise.metadata.botHidden)"
              ></p-toggleswitch>
              <label
                class="form-label fw-semibold mb-0"
                i18n="@@fusionconfig-bot-visible"
              >Bot anzeigen</label>
            </div>
            <!-- Bot-Button anzeigen -->
            <div class="display-option-toggle">
              <p-toggleswitch
                [ngModel]="!this.fusionService.selectedRise.metadata.botButtonHidden"
                (ngModelChange)="this.fusionService.selectedRise.metadata.botButtonHidden = !$event; this.fusionService.updateFusionField('botButtonHidden', this.fusionService.selectedRise.metadata.botButtonHidden)"
              ></p-toggleswitch>
              <label
                class="form-label fw-semibold mb-0"
                i18n="@@fusionconfig-bot-button-visible"
              >Bot-Button anzeigen</label>
            </div>

            <!-- Disclaimer-Platzierung -->
            <div class="display-option-toggle">
              <p-toggleswitch
                [ngModel]="this.fusionService.selectedRise.metadata.disclaimerPlacement === 'fusionview'"
                (ngModelChange)="this.fusionService.selectedRise.metadata.disclaimerPlacement = $event ? 'fusionview' : 'botview'; this.fusionService.updateFusionField('disclaimerPlacement', this.fusionService.selectedRise.metadata.disclaimerPlacement)"
              ></p-toggleswitch>
              <label
                class="form-label fw-semibold mb-0"
                i18n="@@fusionconfig-disclaimer-over-fusionview"
              >Disclaimer über Fusion-View</label>
            </div>

            <!-- Systemsprache -->
            <div class="display-option-toggle">
              <label
                class="form-label fw-semibold mb-0"
                for="riseLangSelect"
                i18n="@@fusionconfig-systemlang"
              >Systemsprache</label>
              <p-select
                id="riseLangSelect"
                [options]="this.systemLanguageOptions"
                optionLabel="label"
                optionValue="value"
                [(ngModel)]="this.fusionService.selectedRise.metadata.botlang"
                (ngModelChange)="this.fusionService.updateFusionField('botlang', this.fusionService.selectedRise.metadata.botlang)"
              ></p-select>
            </div>
          </div>
          <!-- Preview Wireframe -->
          <div class="display-preview">
            <div class="display-preview-frame">
              @if (this.fusionService.selectedRise.metadata.viewMode === 'split' || !this.fusionService.selectedRise.metadata.viewMode) {
                <div class="preview-split">
                  <div class="preview-content-area">
                    <div class="preview-content-line"></div>
                    <div class="preview-content-line short"></div>
                    <div class="preview-content-line"></div>
                  </div>
                  @if (!this.fusionService.selectedRise.metadata.botHidden) {
                    <div
                      class="preview-bot-area"
                      >
                      <div class="preview-bot-header"></div>
                      <div class="preview-bot-messages">
                        <div class="preview-bot-bubble"></div>
                        <div class="preview-bot-bubble user"></div>
                      </div>
                      <div class="preview-bot-input"></div>
                    </div>
                  }
                </div>
              }
              @if (this.fusionService.selectedRise.metadata.viewMode === 'split-reverse') {
                <div class="preview-split-reverse">
                  <div class="preview-content-area">
                    <div class="preview-content-line"></div>
                    <div class="preview-content-line short"></div>
                    <div class="preview-content-line"></div>
                  </div>
                  @if (!this.fusionService.selectedRise.metadata.botHidden) {
                    <div
                      class="preview-bot-area"
                      >
                      <div class="preview-bot-header"></div>
                      <div class="preview-bot-messages">
                        <div class="preview-bot-bubble"></div>
                        <div class="preview-bot-bubble user"></div>
                      </div>
                      <div class="preview-bot-input"></div>
                    </div>
                  }
                </div>
              }
              @if (this.fusionService.selectedRise.metadata.viewMode === 'window') {
                <div class="preview-window">
                  <div class="preview-content-area full">
                    <div class="preview-content-line"></div>
                    <div class="preview-content-line short"></div>
                  </div>
                  @if (!this.fusionService.selectedRise.metadata.botHidden) {
                    <div
                      class="preview-bot-overlay"
                      >
                      <div class="preview-bot-header"></div>
                      <div class="preview-bot-messages">
                        <div class="preview-bot-bubble"></div>
                        <div class="preview-bot-bubble user"></div>
                      </div>
                      <div class="preview-bot-input"></div>
                    </div>
                  }
                </div>
              }
              @if (this.fusionService.selectedRise.metadata.viewMode === 'full') {
                <div class="preview-full">
                  @if (!this.fusionService.selectedRise.metadata.botHidden) {
                    <div
                      class="preview-bot-area fullscreen"
                      >
                      <div class="preview-bot-header"></div>
                      <div class="preview-bot-messages">
                        <div class="preview-bot-bubble"></div>
                        <div class="preview-bot-bubble user"></div>
                        <div class="preview-bot-bubble"></div>
                      </div>
                      <div class="preview-bot-input"></div>
                    </div>
                  }
                  @if (this.fusionService.selectedRise.metadata.botHidden) {
                    <div
                      class="preview-hidden-label"
                      i18n="@@fusionconfig-preview-hidden"
                    >Bot ausgeblendet</div>
                  }
                </div>
              }
              @if (this.fusionService.selectedRise.metadata.viewMode === 'float') {
                <div class="preview-float">
                  <div class="preview-content-area full">
                    <div class="preview-content-line"></div>
                    <div class="preview-content-line short"></div>
                    <div class="preview-content-line"></div>
                  </div>
                  @if (!this.fusionService.selectedRise.metadata.botHidden) {
                    <div
                      class="preview-bot-float"
                      >
                      <div class="preview-bot-header"></div>
                      <div class="preview-bot-messages">
                        <div class="preview-bot-bubble"></div>
                        <div class="preview-bot-bubble user"></div>
                      </div>
                      <div class="preview-bot-input"></div>
                    </div>
                  }
                </div>
              }
              @if (this.fusionService.selectedRise.metadata.botHidden && this.fusionService.selectedRise.metadata.viewMode !== 'full') {
                <div
                  class="preview-hidden-overlay"
                  >
                  <div class="preview-content-line"></div>
                  <div class="preview-content-line short"></div>
                  <div class="preview-content-line"></div>
                </div>
              }
              @if (!this.fusionService.selectedRise.metadata.botButtonHidden) {
                <div
                  class="preview-bot-fab"
                  >
                  <i class="ri-chat-3-line"></i>
                </div>
              }
            </div>
          </div>
        </div>
      </section>
      <hr class="fusion-divider" />
      <!-- ===== 3. LOGIK-EDITOR ===== -->
      <section class="fusion-section">
        <h6
          class="fusion-section-title"
          i18n="@@fusion-logic-editor-heading"
        >Logik-Editor</h6>
        <p
          class="fusion-section-hint"
          i18n="@@fusion-logic-editor-description"
          >
          Im Logik-Editor kannst du Abläufe und Regeln für diesen Fusion-View per Scripting anpassen.
        </p>
        <p-button
          [outlined]="true"
          severity="primary"
          size="small"
          icon="ri-code-box-line"
          [gotoBlockly]="this.editorItemService.getEditorItemByUniqueId('fusion_'+this.fusionService.selectedRise._id)"
          i18n-label="@@to-scripting"
          label="Zum Scripting"
        ></p-button>
      </section>
    </div>
    <!-- ===== 4. HTML-EDITOR (Erweitert) ===== -->
    @if (this.fusionService.selectedRise.metadata.useStaticHtml) {
      <section class="fusion-section">
        <h6 class="fusion-section-title">
          <i class="ri-code-s-slash-line me-1"></i>
          <span i18n="@@fusionconfig-html-advanced">HTML-Editor (Erweitert)</span>
        </h6>
        <p
          class="fusion-section-hint"
          i18n="@@fusionconfig-html-hint"
          >
          Hier kannst du das HTML des Fusion-Views direkt bearbeiten. Nur für erfahrene Nutzer empfohlen.
        </p>
        <p-button
          [outlined]="true"
          [severity]="showHtmlEditor ? 'primary' : 'secondary'"
          size="small"
          [icon]="showHtmlEditor ? 'ri-eye-off-line' : 'ri-code-s-slash-line'"
          (onClick)="showHtmlEditor = !showHtmlEditor"
          [label]="showHtmlEditor ? 'Editor ausblenden' : 'Editor einblenden'"
        ></p-button>
        @if (showHtmlEditor) {
          <div
            class="mt-3"
            >
            <app-codemirror-html
              [code]="this.fusionService.selectedRise.metadata.staticHtml"
              (finish)="this.fusionService.selectedRise.metadata.staticHtml = $event.code; this.fusionService.updateFusionField('staticHtml', this.fusionService.selectedRise.metadata.staticHtml)"
            ></app-codemirror-html>
            <button
              pButton
              i18n-label="@@show-placeholders"
              label="Platzhalter anzeigen"
              icon="pi pi-info-circle"
              severity="secondary"
              size="small"
              class="mt-2"
              [appPlaceholderInfo]="'basic'"
            ></button>
          </div>
        }
      </section>
    }
  </div>
}
